<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y v-if="user.roleName != 'PRODUCTION_MANAGER' && user.roleName != 'BRANCH_ADMIN'">
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
      
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Warehouse Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Warehouse Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="typeList"
                label="Type"
                v-model="queryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="warehouseList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                  <v-icon v-else medium color="red">cancel</v-icon>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.code }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.location }}</td>
                <td>{{ props.item.returnWarehouseName }}</td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.updatedBy }}</td>
              </tr>
            </template>
            <!--<template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.binList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.name }}</td>
                      <td class="text-xs">{{ subprops.item.binType.typeName }}</td>
                      <td class="text-xs">{{ subprops.item.maxCapacity }}</td>
                      <td class="text-xs">{{ subprops.item.minCapacity }}</td>
                      <td class="text-xs">{{ subprops.item.stockBalance }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.selfExpireInMilliSeconds | format-ms-date-time }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>-->
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
export default {
  name: "WarehouseList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Warehouse",
        disabled: true
      }
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Type", value: "type" },
      { text: "Location", value: "location" },
      { text: "Return Warehouse", value: "returnWarehouseName" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    subHeaders: [
      { text: "Bin Name", sortable: false },
      { text: "Bin Type", sortable: false },
      { text: "Max Capacity", sortable: false },
      { text: "Min Capacity", sortable: false },
      { text: "Stock Balance", sortable: false },
      { text: "Self Expire Date", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    warehouseList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    typeList: [
      { label: "All", value: "" },
      { label: "Ground", value: "GROUND" },
      { label: "Production", value: "PRODUCTION" },
      { label: "Mobile", value: "MOBILE" }
    ],
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      type: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getWarehouseList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "warehouses", query: this.queryParams });
      this.getWarehouseList();
    },
    getWarehouseList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      warehouseService
        .getWarehouseList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.warehouseList = res.data.warehouseDTOList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/warehouse/new");
    },
    onEdit(warehouse) {
      // go to details page
      this.$router.push("/warehouse/" + warehouse.id);
    }
  }
};
</script>
